//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

/**
 * Returns a promise that waits the given number of ms before resolving.
 */
export const wait = (delay: number = 1000) => {
  return new Promise<void>((resolve) => {
    setTimeout(() => {
      resolve();
    }, delay);
  });
};
